import { Link } from 'react-router';
import { styled } from '@mui/material';

export const LogoLink = styled(Link)`
  cursor: pointer;
`;

export default LogoLink;
